import { CartLine } from '@msdyn365-commerce/retail-proxy';
export function calculateSavingPercentAmount(lines?: CartLine[]): number {
    let total = 0;
    lines?.forEach(line => total += line.Quantity || 0);
    if (total > 11) { return 15; }
    if (total > 3) { return 10; }
    return 0;
}